import React from 'react';
import styles from './style.css';
import { Dummy } from '../';

export default class ElMeterCell extends Dummy {

  render() {
    return (
      <div className={styles.electro} id={this.props.div_id}>

        <table className={styles.tg}>
          <tbody>
            <tr >
              <th className={styles.value}>{`${this.getPsValue(this.props.ps[0]).value}(кВт)`}</th>
            </tr>
          </tbody>
        </table>
      </div>

    );
  }
}

ElMeterCell.propTypes = {
    div_id: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/entries/ElMeterCell/index.jsx